module.exports = __webpack_public_path__ + "static/media/comment-alt-plus.f8a1cab6.svg";